<!-- <div class="row"> -->
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo lettera'" [valueInput]="element.tipoLettera?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Data lettera'" [valueInput]="element.dataLettera"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Mittente'" [valueInput]="element.mittente"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
	[labelInput]="'Destinatario'" [valueInput]="element.destinatario.nominativo"></div>
<!-- </div> -->